import React from "react";
import Slider from "react-slick";

const SlickSlider = ({sliderImages, onRender, slidesToShow = 1, className}) => {
    const settings = {
        dots: false,
        centerMode: false,
        infinite: false,
        autoplay: false,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        centerPadding: '32.9%',
        initialSlide: 0,
        speed: 1500,
        autoplaySpeed: 1500,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerPadding: '0%',
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: 2,
                centerPadding: '0',
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerPadding: '0%',
              }
            }
        ],
        className:`common-slider ${className}`
    };

    return(
        <Slider {...settings} infinite={false} slidesToShow={sliderImages?.length<slidesToShow ? sliderImages?.length: slidesToShow}  >
            {sliderImages?.map((elm, index) => {
                if(onRender){
                    return (
                        <React.Fragment>
                            {onRender(elm, index)}
                        </React.Fragment>
                    )
                }
                return(<div className="" key={index}>
                    <div className="imgsldierBlogs">
                    <img src={elm?.view_file_url} alt="logo"/>
                </div>
            </div>)
            })}
        </Slider>
    )
}

export default SlickSlider;